import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../shared/button/button.component';
import { ButtonSize, ButtonState, ButtonType } from '../../../assets/types/dtoTypes';

export type DeclineReason = 'SCHEDULE_CONFLICT' | 'NOT_INTERESTED' | 'ACCEPTED_ANOTHER_OFFER' | 'OTHER';

export interface InterviewDeclineResult {
  reason: DeclineReason;
  notes?: string;
}

@Component({
  selector: 'app-interview-decline-modal',
  templateUrl: './interview-decline-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    TranslateModule,
    ButtonComponent,
  ],
})
export class InterviewDeclineModalComponent {
  private readonly dialogRef = inject<MatDialogRef<InterviewDeclineModalComponent>>(MatDialogRef);

  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonState = ButtonState;
  protected readonly ButtonType = ButtonType;

  readonly reasons: DeclineReason[] = [
    'SCHEDULE_CONFLICT',
    'NOT_INTERESTED',
    'ACCEPTED_ANOTHER_OFFER',
    'OTHER',
  ];

  selectedReason: DeclineReason | null = null;
  notes = '';

  get notesValid(): boolean {
    return this.notes.length <= 1000;
  }

  confirm(): void {
    if (!this.selectedReason || !this.notesValid) return;
    const result: InterviewDeclineResult = {
      reason: this.selectedReason,
      notes: this.notes.trim() || undefined,
    };
    this.dialogRef.close(result);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}